/**
 * Created by Kotkin on 28.06.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import remove from 'lodash/remove';
import { I18nHoc } from 'helpers/i18n';
import Dict from 'api/data-dict';
import Modal, { Header, Content/* , Footer */ } from 'components/modal';
// import { btnThemes } from 'components/button';

import ComplaintContainer from './complaint-container';

import translates from './complaint-i18n.json';

@I18nHoc(translates)
class ComplaintModal extends PureComponent {
  static propTypes = {
    entity: PropTypes.string.isRequired,
    entityId: PropTypes.number.isRequired,
    renderModal: PropTypes.bool,
    onClose: PropTypes.func,
    updateEvent: PropTypes.string,
    url: PropTypes.string,
  };

  constructor(props, ctx) {
    super(props, ctx);
    this.close = this.close.bind(this);
    this.userComplaintHandle = this.userComplaintHandle.bind(this);
    this.changeStep = this.changeStep.bind(this);
    this.goBackwards = this.goBackwards.bind(this);

    this.state = {
      // header: ['На что жалуетесь?'],
      userComplaint: false,
      currentStep: 1,
      unauthorised: false,
    };
  }

  close(closeDD = false, positiveClose = false) {
    // this.setState({ header: ['На что жалуетесь?'] });
    if (closeDD === true) {
      this.modal.renderModal(false, true);
    } else { this.props.onClose(positiveClose); }
  }

  userComplaintHandle(close) {
    if (!close && !this.state.userComplaint) return this.setState({ userComplaint: true });
    if (close && this.state.userComplaint) return this.setState({ userComplaint: false });
  }

  changeStep(newHeader) {
    let newState = { ...this.state };
    let { header, currentStep } = newState;

    currentStep += 1;
    if (header.length < currentStep) header = [...header, newHeader];
    newState = {
      ...newState,
      header,
      currentStep
    };

    if (!isEqual(this.state, newState)) this.setState(newState);
  }

  goBackwards() {
    let newState = { ...this.state };
    const { header } = newState;
    let { currentStep } = newState;

    currentStep -= 1;
    remove(header, item => item === header[currentStep]);
    newState = {
      ...newState,
      header,
      currentStep
    };

    if (!isEqual(this.state, newState)) this.setState(newState);
    this.userComplaintHandle(true);
  }

  render() {
    const {
      // header,
      currentStep, userComplaint, unauthorised
    } = this.state;
    const header = [this.i18n('complaintHeaderText')];
    const { entity, entityId, renderModal, updateEvent, url } = this.props;
    const dictUrl = `domik/complaints/${entity}`;

    return (
      <Modal
        className="complaintModal"
        renderModal={renderModal}
        ref={node => this.modal = node}
        onCloseRequired={this.close}
        size="medium"
      >
        <Header
          closeButton
          buttonAction={this.goBackwards}
          backButton={currentStep > 1}
        >
          {header[currentStep - 1]}
        </Header>
        <Content noPadding adaptiveHeight>
          <Dict
            url={dictUrl}
            injectPropName="data"
          >
            <ComplaintContainer
              entityId={entityId}
              unauthorised={unauthorised}
              closeModal={this.close}
              userComplaintHandle={this.userComplaintHandle}
              userComplaint={userComplaint}
              changeStep={this.changeStep}
              currentStep={currentStep}
              entity={entity}
              updateEvent={updateEvent}
              url={url}
            />
          </Dict>
        </Content>
        {/* userComplaint &&
          <Footer>
            <button close theme={btnThemes.light} data-test="buttonClose">Отмена</button>
            <button
              onClick={() => this.complaintRef.sendComplaint()}
              theme={btnThemes.olive}
            >
              Отправить
            </button>
          </Footer>
        */}
      </Modal>
    );
  }
}

export default ComplaintModal;
